<mat-card class="mx-2 my-2 shadow">
  <form [formGroup]="editCommentForm" (ngSubmit)="onSubmit()">
    <h5 class="content-label-each" translate>
      Edit Comment
    </h5>
    <div class="buss-info-details content-details-blk">
      
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <div class="row g-0">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                Visit Type<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select
                    formControlName="visitType"
                    placeholder="Select Visit Type"
                    required
                  >
                    <mat-option [value]="type" *ngFor="let type of visitTypes" >{{type}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
        </div>
        <div class="row g-0">
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
            <h4 class="form-item-label" >
            {{f.visitType.value}} Duration (min)<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center">
            <div class="form-item-input">
              <mat-form-field class="w-100" appearance="outline">
                <input
                  matInput
                  type="number"
                  placeholder="Enter  {{f.visitType.value}} Duration"
                  formControlName="callDuration"
                  required
                />
              </mat-form-field>
              <div *ngIf="f.callDuration.touched && f.callDuration.invalid">
                <div *ngIf="f.callDuration.errors.required">
                  <mat-hint class="text-danger ms-2">
                     {{f.visitType.value}} Duration is Required</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
          <div class="row g-0">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <h4 class="form-item-label" >
                {{f.visitType.value}} Date<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center">
              <div class="form-item-input">
                
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    [matDatepicker]="picker"
                    [max]="newDate"
                    readonly
                    formControlName="visitedDate"
                    placeholder="Enter  {{f.visitType.value}} Date"
                  />
                  <mat-datepicker-toggle matSuffix [for]="picker">
                    <mat-icon matDatepickerToggleIcon
                      >keyboard_arrow_down</mat-icon
                    >
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <div *ngIf="f.visitedDate.touched && f.visitedDate.invalid">
                  <div *ngIf="f.visitedDate.errors.required">
                    <mat-hint class="text-danger ms-2">
                      {{f.visitType.value}} Date is Required
                      </mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          
      
          
          <div class="row g-0">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <h4 class="form-item-label" >
                {{f.visitType.value}}  Time<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <ngx-timepicker-field [controlOnly]="true" formControlName="visitedTime"></ngx-timepicker-field>
                  <input matInput class="d-none" />
                  <div *ngIf="f.visitedTime.touched && f.visitedTime.invalid">
                    <div *ngIf="f.visitedTime.errors.required">
                      <mat-hint class="text-danger ms-2">
                        {{f.visitType.value}} Time is Required
                      </mat-hint>
                    </div>
                  </div>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          
          <div class="row g-0">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                Spoke With<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="w-100" appearance="outline">
                  <input
                    matInput
                    placeholder="Enter Spoke With"
                    formControlName="spokeWith"
                  />
                </mat-form-field>
                <div *ngIf="f.spokeWith.touched && f.spokeWith.invalid">
                  <div *ngIf="f.spokeWith.errors.required">
                    <mat-hint class="text-danger ms-2">
                        Spoke With is Required
                      </mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
            <div class="row g-0">
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-start">
                <h4 class="form-item-label mt-3" translate>
                  Comment<span class="required">*</span>
                </h4>
              </div>
                <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center">
                  <div class="form-item-input mb-3">
                    <mat-form-field class="w-100" appearance="outline">
                      <textarea required label="comment" title="comment" formControlName="comment" matInput></textarea>
                    </mat-form-field>
                    <div *ngIf="f.comment.touched && f.comment.invalid">
                      <div *ngIf="f.comment.errors.required">
                        <mat-hint class="text-danger ms-2">
                          Comment is Required</mat-hint
                        >
                      </div>
                    </div>
                  </div>
                </div>
            </div>
           
            
        </div>
      </div>
    </div>

    <div class="form-footer">
      <ul class="list-inline text-center">
        <li class="list-inline-item">
          <button mat-raised-button [disabled]="checkSubmitDisplayed()" color="primary" type="submit" class="rounded-0">
            <span translate class="translate">pages.newRetailer.save</span>
          </button>
        </li>
        <li class="list-inline-item">
          <button mat-stroked-button color="primary" type="button" class="rounded-0" (click)="onCancel()">
            <span translate class="translate">pages.newRetailer.cancel</span>
          </button>
        </li>
        <li class="list-inline-item"></li>
      </ul>
    </div>
  </form>
</mat-card>